<template>
  <div class="detail-container">
    <div class="hot-commend">
      <div class="title">相似药品</div>
      <div
        class="item"
        v-for="item of info.similarity"
        :key="item.id"
        @click="goDetial(item.id)"
      >
        <div class="img">
          <img :src="item.image" alt="" />
        </div>
        <div class="product-name">{{ item.store_name }}</div>
        <div class="price">￥{{ item.price }}</div>
      </div>
    </div>
    <div class="item-intro-show">
      <div class="item-intro-detail" ref="itemIntroDetail">
        <div class="item-intro-nav item-tabs">
          <Tabs @on-click="getIndex">
            <TabPane label="商品介绍">
              <div
                class="item-intro-img"
                ref="itemIntroGoods"
                v-show="index === 0"
              >
                <div
                  v-html="info.storeInfo.description"
                  v-if="info.storeInfo"
                ></div>
              </div>
            </TabPane>
            <TabPane label="规格参数">
              <div
                class="item-param-container"
                ref="itemRemarks"
                v-if="info.storeInfo"
              >
                <span class="item-param-box">
                  <span class="item-param-title">通用名: </span>
                  <span class="item-param-content">{{
                    info.storeInfo.general_name
                  }}</span>
                </span>
                <span class="item-param-box">
                  <span class="item-param-title">生产商: </span>
                  <span class="item-param-content">{{
                    info.storeInfo.Authorized_holder
                  }}</span>
                </span>
                <span class="item-param-box">
                  <span class="item-param-title">国家: </span>
                  <span class="item-param-content">{{
                    info.storeInfo.country
                  }}</span>
                </span>
                <span class="item-param-box">
                  <span class="item-param-title">单位: </span>
                  <span class="item-param-content">{{
                    info.storeInfo.unit_name
                  }}</span>
                </span>
              </div>
            </TabPane>
            <!-- <TabPane label="售后保障">
              <ShowProductWarranty ref="protext"></ShowProductWarranty>
            </TabPane> -->
            <TabPane label="商品评价">
              <div class="remarks-container" ref="itemAnalyse">
                <div v-if="nodata">
                  <div class="remarks-analyse-box" v-show="index === 3">
                    <div class="remarks-analyse-goods">
                      <i-circle
                        :percent="replyResult.reply_chance | changeInt"
                        stroke-color="#e4393c"
                      >
                        <span class="remarks-analyse-num"
                          >{{ replyResult.reply_chance }}%</span
                        >
                        <p class="remarks-analyse-title">好评率</p>
                      </i-circle>
                    </div>
                    <div class="remarks-analyse-tags">
                      <Tag
                        checkable
                        :color="tagsColor[index % 4]"
                        v-for="(item, index) in goodsInfo"
                        :key="index"
                        >{{ item }}</Tag
                      >
                    </div>
                  </div>
                  <div class="remarks-bar">
                    <span
                      :class="active === 0 ? 'active' : ''"
                      @click="changeIndex(0)"
                      >全部({{ replyResult.sum_count }})</span
                    >
                    <span
                      :class="active === 1 ? 'active' : ''"
                      @click="changeIndex(1)"
                      >好评({{ replyResult.good_count }})</span
                    >
                    <span
                      :class="active === 2 ? 'active' : ''"
                      @click="changeIndex(2)"
                      >中评({{ replyResult.in_count }})</span
                    >
                    <span
                      :class="active === 3 ? 'active' : ''"
                      @click="changeIndex(3)"
                      >差评({{ replyResult.poor_count }})</span
                    >
                  </div>
                  <div
                    class="remarks-box"
                    v-for="(item, index) in replyList"
                    :key="index"
                  >
                    <div class="remarks-user">
                      <Avatar icon="person" />
                      <span class="remarks-user-name">{{ item.nickname }}</span>
                    </div>
                    <div class="remarks-content-box">
                      <p>
                        <Rate
                          disabled
                          :value="Number(item.star)"
                          allow-half
                          class="remarks-star"
                        ></Rate>
                      </p>
                      <p class="remarks-content">{{ item.comment }}</p>
                      <p class="remarks-sub">
                        <span class="remarks-item">{{ item.suk }}</span>
                        <span class="remarks-time">{{ item.add_time }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="remarks-page" v-if="replyResult.sum_count > 10">
                    <Page
                      :total="replyResult.sum_count"
                      size="small"
                      @on-page-size-change="sizeChange"
                      @on-change="changePage"
                      show-elevator
                      show-sizer
                    ></Page>
                  </div>
                </div>
                <div v-else class="no-remark">
                  暂无相关评价
                </div>
              </div>
            </TabPane>
          </Tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import ShowProductWarranty from "@/components/pc/goodsDetail/ShowProductWarranty";
import { getReplyConfig, getReplyList } from "@api/store";
export default {
  name: "ShowGoodsDetail",
  props: ["info"],
  data() {
    return {
      tagsColor: ["blue", "green", "red", "yellow"],
      heightCss: "",
      index: 0,
      introHeight: 0,
      id: 0,
      param: {
        page: 1,
        limit: 10,
        type: 0 // 0为全部，1为好评，2为中评，3为差评
      },
      replyResult: {},
      replyList: [],
      active: 0,
      nodata: true,
      goodsInfo: []
    };
  },
  methods: {
    changeHeight() {
      let heightCss =
        this.heightCss ||
        window.getComputedStyle(this.$refs.itemIntroGoods).height;
      heightCss = parseInt(heightCss.substr(0, heightCss.length - 2)) + 220;
      this.$refs.itemIntroDetail.style.height = heightCss + "px";
    },
    // Tabs的内置触发方法，只能写在tabs标签上
    getIndex(e) {
      this.index = e;
      if (e === 0) {
        this.heightCss = this.introHeight;
      } else if (e === 1) {
        this.heightCss = window.getComputedStyle(this.$refs.itemRemarks).height;
      } else if (e === 2) {
        this.heightCss = window.getComputedStyle(
          this.$refs.protext.$refs.protectContent
        ).height;
      } else {
        this.heightCss = window.getComputedStyle(this.$refs.itemAnalyse).height;
      }
      this.changeHeight();
    },
    getReplyInfo() {
      getReplyConfig(this.id)
        .then(res => {
          this.replyResult = res.data;
        })
        .catch(() => {
          this.nodata = false;
        });
    },
    getReplyList() {
      getReplyList(this.id, this.param).then(res => {
        this.replyList = res.data;
      });
    },
    changeIndex(index) {
      this.active = index;
      this.param.type = index;
      this.getReplyList();
    },
    sizeChange(num) {
      this.param.limit = num;
      this.getReplyList();
    },
    changePage(page) {
      this.param.page = page;
      this.getReplyList();
    },
    goDetial(id) {
      this.$router.push("/goodsDetail/" + id);
    }
  },
  created() {
    this.id = this.$route.params.id;
    this.getReplyInfo();
    this.getReplyList();
  },
  updated() {
    this.$nextTick(() => {
      if (
        window.getComputedStyle(this.$refs.itemIntroGoods).height !== "auto"
      ) {
        this.introHeight = window.getComputedStyle(
          this.$refs.itemIntroGoods
        ).height;
      }
      setTimeout(this.changeHeight, 100);
    });
  },
  components: {
    // ShowProductWarranty
  },
  filters: {
    changeInt(val) {
      return parseFloat(val);
    }
  }
};
</script>

<style scoped>
.detail-container /deep/ .ivu-tabs-nav-scroll {
  background: url(/assets/pc/images/goodsDetail/tab_bg.png);
}

.detail-container {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
}
.hot-commend {
  width: 200px;
  background: #fff;
}
.hot-commend .title {
  height: 39px;
  line-height: 39px;
  padding: 0px 10px;
  border-bottom: 1px solid #e5e5e5;
  font-weight: bold;
  color: #000;
  font-size: 14px;
}
.hot-commend .item {
  padding: 5px 20px;
  cursor: pointer;
}
.hot-commend .item .img {
  width: 160px;
  height: 100px;
  text-align: center;
}
.hot-commend .item .img img {
  width: 100px;
  height: 100px;
}
.hot-commend .item .product-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 20px;
  line-height: 20px;
  color: #646965;
}
.hot-commend .item .price {
  color: #f54343;
  height: 20px;
  line-height: 20px;
  font-family: Verdana, Geneva, sans-serif;
}
.item-intro-show {
  width: 980px;
  display: flex;
  flex-direction: row;
  background-color: #fff;
}
.item-intro-detail {
  width: 100%;
}
.item-intro-nav {
  width: 100%;
  height: 38px;
  background-color: #f7f7f7;
  border-bottom: 1px solid #4889f6;
}
.item-intro-nav ul {
  margin: 0px;
  padding: 0px;
  list-style: none;
}
.item-intro-nav li {
  float: left;
  height: 100%;
  width: 120px;
  line-height: 38px;
  text-align: center;
  color: #e4393c;
}
.item-intro-nav li:first-child {
  background-color: #e4393c;
  color: #fff;
}
.item-intro-img {
  width: 100%;
}
.item-intro-img img {
  width: 100%;
}
.item-param-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
}
.item-param-box {
  padding: 5px;
  padding-left: 30px;
  width: 240px;
  height: 36px;
  font-size: 14px;
}
.item-param-title {
  color: #232323;
}
.item-param-content {
  color: #999;
}
.remarks-title {
  padding-left: 15px;
  height: 36px;
  font-size: 16px;
  font-weight: bolder;
  line-height: 36px;
  color: #666666;
  background-color: #f7f7f7;
}
.remarks-analyse-box {
  padding: 15px;
  display: flex;
  align-items: center;
}
.remarks-analyse-goods {
  margin-left: 15px;
  margin-right: 15px;
}
.remarks-analyse-num {
  font-size: 26px;
}
.remarks-analyse-title {
  font-size: 12px;
  line-height: 20px;
}
.remarks-bar {
  padding-left: 15px;
  height: 36px;
  line-height: 36px;
  color: #666666;
  background-color: #f7f7f7;
}
.remarks-bar span {
  margin-right: 15px;
  padding: 10px;
}
.remarks-bar span.active {
  background: #e4393c;
  color: #fff;
}
.remarks-box {
  padding: 15px;
  display: flex;
  flex-direction: row;
  border-bottom: 1px #ccc dotted;
}
.remarks-user {
  width: 180px;
}
.remarks-user-name {
  padding-left: 15px;
}
.remarks-content-box {
  width: calc(100% - 180px);
}
.remarks-star {
  background-color: #fff;
}
.remarks-content {
  font-size: 14px;
  color: #232323;
  line-height: 28px;
}
.remarks-sub {
  margin-top: 15px;
  color: #ccc;
}
.remarks-time {
  margin-left: 15px;
}
.remarks-page {
  margin: 15px;
  display: flex;
  justify-content: flex-end;
}
</style>

<style>
/* 改变便签页样式 */
.ivu-tabs-ink-bar {
  background-color: #4889f6;
}
.item-tabs > .ivu-tabs > .ivu-tabs-bar .ivu-tabs-tab {
  border-radius: 0px;
  color: #666;
  height: 38px;
}
.item-tabs > .ivu-tabs > .ivu-tabs-bar .ivu-tabs-tab-active {
  color: #fff;
  background-color: #4889f6;
}
.item-tabs > .ivu-tabs > .ivu-tabs-bar .ivu-tabs-tab-active:before {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  color: #fff;
  background: #f7f7f7;
  position: absolute;
  top: 0;
  left: 0;
}
.ivu-rate-star-full:before,
.ivu-rate-star-half .ivu-rate-star-content:before {
  color: #4889f6;
}
.no-remark {
  line-height: 100px;
  text-align: center;
  font-size: 16px;
}
</style>
